import { CustomColorPallet } from '@barboxx/utils';

import { LogoColors } from './types';

interface Props {
    color?: LogoColors;
    height?: number;
}

export const LogoWordMark = (props: Props) => {
    const { color = 'white', height = 35, ...rest } = props;

    let textColor: string;
    switch (color) {
        case 'gray':
            textColor = CustomColorPallet.logoColors.gray;
            break;
        case 'primary':
            textColor = CustomColorPallet.logoColors.teal;
            break;
        case 'white':
            textColor = CustomColorPallet.logoColors.white;
    }

    const aspectRatio = 253 / 35;
    const calcedWidth = height * aspectRatio;

    return (
        <svg
            width={calcedWidth}
            height={height}
            viewBox="0 0 253 35"
            preserveAspectRatio="xMidYMid meet"
            {...rest}
        >
            <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Artboard"
                    transform="translate(-302.000000, -344.000000)"
                    fill={textColor}
                    fillRule="nonzero"
                >
                    <g id="Top" transform="translate(302.000000, 190.996000)">
                        <g
                            id="BABRBOXX"
                            transform="translate(-0.000000, 153.004000)"
                        >
                            <g
                                id="X"
                                transform="translate(220.500000, 0.000000)"
                            >
                                <polygon
                                    id="Path"
                                    points="32.375 35 19.2570291 16.8810072 19.70521 16.2620141 31.4786399 0 25.316567 0 16.6241739 12.0064392 16.1759931 12.6254324 15.7278122 12.0064392 7.03541912 0 0.875 0 12.6467754 16.2620141 13.0949562 16.8826892 13.0883412 16.8910992 16.171031 21.1449921 16.1759923 21.1382641 26.2129271 35"
                                ></polygon>
                                <polygon
                                    id="Path"
                                    points="6.2555588 35 14.875 22.7985345 11.7455422 18.375 0 35"
                                ></polygon>
                            </g>
                            <g
                                id="X"
                                transform="translate(182.000000, 0.000000)"
                            >
                                <polygon
                                    id="Path"
                                    points="32.375 35 19.2570291 16.8810072 19.70521 16.2620141 31.4786399 0 25.316567 0 16.6241739 12.0064392 16.1759931 12.6254324 15.7278122 12.0064392 7.03541912 0 0.875 0 12.6467754 16.2620141 13.0949562 16.8826892 13.0883412 16.8910992 16.171031 21.1449921 16.1759923 21.1382641 26.2129271 35"
                                ></polygon>
                                <polygon
                                    id="Path"
                                    points="6.2555588 35 14.875 22.7985345 11.7455422 18.375 0 35"
                                ></polygon>
                            </g>
                            <g
                                id="O"
                                transform="translate(147.000000, 0.000000)"
                            >
                                <path
                                    d="M17.5,0 C27.1661864,0 35.0016808,7.83549521 35,17.5 C35,27.1645056 27.1645046,35 17.5,35 C7.83549434,35 0,27.1645048 0,17.5 C0,7.8354944 7.83549515,0 17.5,0 Z M17.5,5.25 C10.7451415,5.25 5.25,10.7451415 5.25,17.5 C5.25,24.2548585 10.7451415,29.75 17.5,29.75 C24.2548585,29.75 29.75,24.2548585 29.75,17.5 C29.75,10.7451415 24.2548585,5.25 17.5,5.25 Z"
                                    id="Combined-Shape"
                                ></path>
                            </g>
                            <g
                                id="B"
                                transform="translate(112.000000, 0.000000)"
                            >
                                <path
                                    d="M18.204476,0 C21.7655961,0 24.8854665,1.92028433 26.6164474,4.79502183 L26.7898378,5.09410676 L26.824703,5.15928986 C27.6086597,6.59456839 28.055928,8.24782094 28.055928,10.0067072 C28.055928,11.6686794 27.6576816,13.2342506 26.9524355,14.6134478 L26.7537341,14.9849106 C26.4741505,15.479378 26.1531402,15.9466814 25.7971415,16.3838046 C26.3348536,16.7080836 26.8407124,17.0811552 27.3059708,17.5 C28.1328392,18.2444681 28.8342744,19.1281032 29.3772704,20.1140171 C30.1727806,21.5576798 30.625,23.2209924 30.625,24.9916162 C30.625,26.7538565 30.1760814,28.4121391 29.3871727,29.850771 C27.7512426,32.8416994 24.6476109,34.8899712 21.0650533,34.9957037 L20.7735457,35 L0,35 L0,7.73977112 L4.95130929,7.73977112 L4.95130929,14.9061029 L19.0130253,14.9061029 C21.3252864,14.5137484 23.0929035,12.4664647 23.0929035,10.0067064 C23.0929035,7.71091186 21.5518416,5.77301543 19.464455,5.20818799 L19.2671923,5.15928906 L0,5.15928906 L0,0 L18.204476,0 Z M22.22528,20.125 L5.25,20.125 L5.25,29.75 L22.3273631,29.75 C24.5664796,29.2776174 26.25,27.3035559 26.25,24.9466163 C26.25,22.6252145 24.6151821,20.6754302 22.4258113,20.1672016 L22.22528,20.125 Z"
                                    id="Combined-Shape"
                                ></path>
                            </g>
                            <g
                                id="R"
                                transform="translate(74.375000, 0.000000)"
                            >
                                <path
                                    d="M32.375,35 L22.7619411,19.2270013 C27.2378344,17.2741998 28.4880216,12.6610152 28.4880216,10.0075763 C28.4880216,7.35413739 27.2378344,4.65745404 26.078815,3.4966456 C24.8808804,2.25602327 22.1985402,0 18.484846,0 L0,0 L0,5.15973717 L19.5639293,5.15973717 C21.784437,5.65273734 23.4485609,7.63983178 23.4485609,10.0075755 C23.4485609,12.4675475 21.6537205,14.515009 19.3058479,14.9073976 L5.02756517,14.9073976 L5.02756517,7.74044336 L0,7.74044336 L0,20.0328205 L0,20.1157642 L0,34.9757917 L4.95283137,34.9757917 L4.95283137,20.1157642 L17.4185912,20.1157642 L26.4850592,35 L32.375,35 Z"
                                    id="Path"
                                ></path>
                            </g>
                            <g
                                id="A"
                                transform="translate(31.500000, 0.000000)"
                            >
                                <polygon
                                    id="Path"
                                    points="38.5 35 22.4112703 6.00281967 19.0793193 0 19.0777405 0.00367536607 15.75 6.00282047 19.0793193 12.0040652 31.8371501 35"
                                ></polygon>
                                <polygon
                                    id="Path"
                                    points="6.56755934 35 17.5 14.8334026 14.2336034 8.75 0 35"
                                ></polygon>
                            </g>
                            <g id="B">
                                <path
                                    d="M18.204476,0 C21.7655961,0 24.8854665,1.92028433 26.6164474,4.79502183 L26.7898378,5.09410676 L26.824703,5.15928986 C27.6086597,6.59456839 28.055928,8.24782094 28.055928,10.0067072 C28.055928,11.6686794 27.6576816,13.2342506 26.9524355,14.6134478 L26.7537341,14.9849106 C26.4741505,15.479378 26.1531402,15.9466814 25.7971415,16.3838046 C26.3348536,16.7080836 26.8407124,17.0811552 27.3059708,17.5 C28.1328392,18.2444681 28.8342744,19.1281032 29.3772704,20.1140171 C30.1727806,21.5576798 30.625,23.2209924 30.625,24.9916162 C30.625,26.7538565 30.1760814,28.4121391 29.3871727,29.850771 C27.7512426,32.8416994 24.6476109,34.8899712 21.0650533,34.9957037 L20.7735457,35 L0,35 L0,7.73977112 L4.95130929,7.73977112 L4.95130929,14.9061029 L19.0130253,14.9061029 C21.3252864,14.5137484 23.0929035,12.4664647 23.0929035,10.0067064 C23.0929035,7.71091186 21.5518416,5.77301543 19.464455,5.20818799 L19.2671923,5.15928906 L0,5.15928906 L0,0 L18.204476,0 Z M22.22528,20.125 L5.25,20.125 L5.25,29.75 L22.3273631,29.75 C24.5664796,29.2776174 26.25,27.3035559 26.25,24.9466163 C26.25,22.6252145 24.6151821,20.6754302 22.4258113,20.1672016 L22.22528,20.125 Z"
                                    id="Combined-Shape"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
